export const getItemName = (item: any) => {
    const getAirports = (list:any[]) => {
      if (list && Array.isArray(list) && list.length !== 0) {
        let listAirports = list.map((data) => `${data.boardPoint}/${data.offPoint} - `)
        let concant = listAirports.join('')
        let delete_last_characters = concant?.slice(0, -2)
        return delete_last_characters
      }
    }
    const product_type = item.product?.ref_table_detail

    if(product_type == 'air_detail'){
        return getAirports(item?.segments?.[0]?.itineraryGroup)
    }
    if(product_type == 'hotel_detail'){
        return item?.name
    }
    if(product_type == 'car_detail'){
        return item?.provider
    }
    if(product_type == 'train_detail_segment'){
        return `${item?.segments?.[0]?.origin_name}/${item?.segments?.[0]?.arrival_name}`
    }
    if(product_type == 'train_detail_passes'){
        return item?.passes?.[0]?.company_name
    }
    if(product_type == 'transfer_detail'){
        return item?.pickup_origin
    }
    if(product_type == 'assistance_detail'){
        return `${item.destination} / ${item.name}`
    }
    if(product_type == 'other_detail'){
        return item?.name
    }
}